import { render, staticRenderFns } from "./activeDetail.vue?vue&type=template&id=25c483ce&scoped=true&"
import script from "./activeDetail.vue?vue&type=script&lang=js&"
export * from "./activeDetail.vue?vue&type=script&lang=js&"
import style0 from "./activeDetail.vue?vue&type=style&index=0&id=25c483ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c483ce",
  null
  
)

component.options.__file = "activeDetail.vue"
export default component.exports